let tipEl = null;

function getTip() {
  if (!tipEl) {
    tipEl = document.createElement('div');
    tipEl.className = 'ui-hint';
    document.body.appendChild(tipEl);
  }
  return tipEl;
}

function hideTip() {
  if (tipEl) tipEl.classList.remove('is-show');
}

function showTip(el) {
  const text = el.__hintText;
  if (!text) return;
  const tip = getTip();
  tip.textContent = text;
  tip.classList.add('is-show');
  const r = el.getBoundingClientRect();
  const tw = tip.offsetWidth;
  const th = tip.offsetHeight;
  let left = r.left + r.width / 2;
  left = Math.min(window.innerWidth - tw / 2 - 8, Math.max(tw / 2 + 8, left));
  const placeBelow = r.top < th + 14;
  tip.classList.toggle('is-below', placeBelow);
  tip.style.left = `${left}px`;
  tip.style.top = `${placeBelow ? r.bottom + 8 : r.top - 8}px`;
}

function bindHint(el) {
  if (el.__hintBound) return;
  el.__hintBound = true;
  el.__hintShow = () => showTip(el);
  el.__hintHide = hideTip;
  el.addEventListener('mouseenter', el.__hintShow);
  el.addEventListener('mouseleave', el.__hintHide);
  el.addEventListener('focus', el.__hintShow);
  el.addEventListener('blur', el.__hintHide);
}

function unbindHint(el) {
  if (!el.__hintBound) return;
  el.removeEventListener('mouseenter', el.__hintShow);
  el.removeEventListener('mouseleave', el.__hintHide);
  el.removeEventListener('focus', el.__hintShow);
  el.removeEventListener('blur', el.__hintHide);
  hideTip();
  el.__hintBound = false;
}

export default {
  install(Vue) {
    window.addEventListener('scroll', hideTip, true);
    window.addEventListener('resize', hideTip);
    Vue.directive('hint', {
      bind(el, binding) {
        el.__hintText = binding.value == null ? '' : String(binding.value);
        bindHint(el);
      },
      update(el, binding) {
        el.__hintText = binding.value == null ? '' : String(binding.value);
      },
      unbind(el) {
        unbindHint(el);
      },
    });
  },
};
